import React from 'react';
import { Alert, CircularProgress, Stack, Typography } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEmailConfirmation } from 'api/useProviderEmailChange';
import { Button } from 'components/Elements/Buttons/Button';
import { PageWrapper } from 'components/Modules/Wrappers/PageWrapper';

export const EmailConfirmPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [token] = React.useState(() => searchParams.get('token')?.trim() ?? '');
  const confirmation = useEmailConfirmation(token, {
    onSuccess: () => {
      if (searchParams.has('token')) {
        navigate('/email/confirm', { replace: true });
      }
    },
  });
  const finished = confirmation.status !== 'loading';

  return (
    <PageWrapper>
      <Typography mb={2} variant="h3" component="h1" fontSize={{ xs: 28, md: 36 }}>
        Confirm email address
      </Typography>
      {confirmation.status === 'loading' && (
        <Stack direction="row" spacing={2} alignItems="center" aria-live="polite">
          <CircularProgress size={28} />
          <Typography>Confirming your email address</Typography>
        </Stack>
      )}
      {confirmation.status === 'success' && (
        <Alert severity="success" sx={{ mb: 2 }}>
          <Typography>{confirmation.message}</Typography>
          {confirmation.maskedEmail && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              The address on file is now {confirmation.maskedEmail}.
            </Typography>
          )}
        </Alert>
      )}
      {confirmation.status === 'error' && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {confirmation.message}
        </Alert>
      )}
      {finished && (
        <Stack direction="row" spacing={2} flexWrap="wrap">
          {confirmation.status === 'error' && confirmation.retry && (
            <Button size="medium" variant="outlined" color="primary" type="button" onClick={confirmation.retry}>
              Try again
            </Button>
          )}
          <Button size="medium" variant="contained" color="primary" type="button" onClick={() => navigate('/search')}>
            Return to provider search
          </Button>
        </Stack>
      )}
    </PageWrapper>
  );
};
